import React from 'react';

interface ActivityPriorityBadgeProps {
    priority: string;
    size?: 'sm' | 'md';
}

const toneMap: Record<string, string> = {
    low: 'bg-slate-100 text-slate-600 ring-slate-200',
    normal: 'bg-blue-50 text-blue-700 ring-blue-200',
    high: 'bg-orange-50 text-orange-700 ring-orange-200',
    urgent: 'bg-red-50 text-red-700 ring-red-200',
};

const dotMap: Record<string, string> = {
    low: 'bg-slate-400',
    normal: 'bg-blue-500',
    high: 'bg-orange-500',
    urgent: 'bg-red-500',
};

const ActivityPriorityBadge: React.FC<ActivityPriorityBadgeProps> = ({ priority, size = 'sm' }) => {
    const key = String(priority || 'normal').toLowerCase();
    const tone = toneMap[key] || toneMap.normal;
    const dot = dotMap[key] || dotMap.normal;
    const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs';
    return (
        <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full font-bold capitalize ring-1 ring-inset ${tone} ${sizeClasses}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
            {key}
        </span>
    );
};

export default ActivityPriorityBadge;
